import axiosClient from "../axios/axiosClient";

export function getEvents() {
  return axiosClient.get("/events");
}

export function getEvent(eventId) {
  return axiosClient.get(`/events/${eventId}`);
}

export function createEvent(data) {
  return axiosClient.post("/events", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateEvent = (eventId, data) => {
  return axiosClient.post(`/events/${eventId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function deleteEvent(eventId) {
  return axiosClient.delete(`/events/${eventId}`);
}
